// global
import { replace } from 'react-router-redux';
// local
import * as SimpleModal from '../simpleModal';

const ACTION_KEY = 'MODAL_CONFIRM_EDIT_BACK';

export function openModal() {
    return SimpleModal.openModal(ACTION_KEY);
}

export function closeModal() {
    return SimpleModal.closeModal(ACTION_KEY);
}

export function onConfirmClose() {
    return dispatch => {
        dispatch(closeModal());
        dispatch(replace('/confirm-delivery'));
    };
}
